function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0277BD"
    },
    d: "M 41 5 L 7 5 L 10 39 L 24 43 L 38 39 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#039BE5"
    },
    d: "M 24 8 L 24 39.898438 L 35.199219 36.699219 L 37.699219 8 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M 33.101563 13 L 24 13 L 24 17 L 28.898438 17 L 28.601563 21 L 24 21 L 24 25 L 28.398438 25 L 28.101563 29.5 L 24 30.898438 L 24 35.101563 L 31.898438 32.5 L 32.601563 21 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEEEEE"
    },
    d: "M 24 13 L 24 17 L 15.101563 17 L 14.800781 13 Z M 19.398438 21 L 19.601563 25 L 24 25 L 24 21 Z M 19.800781 27 L 15.800781 27 L 16.101563 32.5 L 24 35.101563 L 24 30.898438 L 19.898438 29.5 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css3.f1f1ae8bbaa0bd572ffabfffa1d7c893.svg";
export { ForwardRef as ReactComponent };